import api from './api'

export default {
  get() {
     var parm={'from':'profile'};
    return api.get('profile',{params:parm})
  },
  post(data){
    return api.post('profile',data);
  },
  // billing
  getBilling(){
    var parm={'from':'profile'};
    return api.get('profile/billing',{params:parm})
  },
  UpdateBilling(params){
    return api.post('profile/billing/update',params);
  }
}
